

























import { Component, Vue, Watch } from 'vue-property-decorator';
import Banner from '@/components/banner/Bannerwrap.vue';
import KnowMoreBtn from '@/components/know-more-button/Know-more-btn.vue';

import axios from 'axios';
import {
  getSinglePageUrl,
} from '@/util/lang.ts';
import imgs from '@/util/imgs.ts';

@Component({
  components: {
    Banner,
    KnowMoreBtn,
  },
})
export default class Newsdetail extends Vue {
  // initial data
  private imgs = imgs;
  private iszoom: boolean = false;

  private item: object = {
    // TITLE: '',
    // SHOWTIME: '',
    CONTENT: '',
  };

  @Watch('$store.state.lang')
  private onLangChanged() {
    this.fetchData();
  }

  // lifecycle hook
  private mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      this.iszoom = true;
    });

    this.fetchData();
  }

  private fetchData() {
    // window.console.log(this.$route.params.id);
    // const id = this.$route.params.id;
    // if (id) {
    const url = getSinglePageUrl(this.$store.state.lang);
    axios.get(url).then((res: any) => {
      // window.console.log(res.data);
      this.item = res.data;
    });
    // }
  }

  private backList() {
    // window.console.log('backList');
    this.$router.back();
  }
}
